module.exports = __webpack_public_path__ + "img/first_section_strawberries.282be5ec.jpeg";